import classNames from 'classnames';
import { FC, HTMLProps, ReactNode, memo, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useBoolean, useWindowSize } from 'react-easyrocket';
import { ScrollToTopButton } from 'src/components/ScrollToTopButton';
import { Navbar } from 'src/components/Navbar';
import { TopbarSearch } from 'src/components/TopbarSearch';

import { GPTBanners } from 'src/modules/gptBanners/components/GPTBanners';

interface FullScreenContainerProps extends HTMLProps<HTMLDivElement> {
  children: ReactNode;
  additionalClassName?: string;
}

const _FullScreenContainer: FC<FullScreenContainerProps> = ({
  children,
  additionalClassName,
  ...rest
}) => {
  const [buttonVisible, showButton, hideButton] = useBoolean();
  const { isMobileLayout } = useWindowSize();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        showButton();
      } else {
        hideButton();
      }
    });
  }, [hideButton, showButton]);

  const handleScrollTo = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={classNames(
        'w-full min-h-screen flex flex-col justify-start items-center',
        additionalClassName
      )}
      {...rest}>
      {!pathname.includes('info_pages') && !pathname.includes('faq') && <GPTBanners />}
      <ScrollToTopButton onClick={handleScrollTo} visible={buttonVisible} />
      {children}
      {isMobileLayout && (
        <>
          <div className="fixed bottom-0 w-full z-[500]">
            <Navbar />
          </div>
          <TopbarSearch />
        </>
      )}
    </div>
  );
};

export const FullScreenContainer = memo(_FullScreenContainer);
